/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import Reconciliation
import RegenerateSettlement from '../views/reconciliation/RegenerateSettlement.vue';
import TransactionReconciliation from '../views/reconciliation/TransactionReconciliation.vue';

import { setBreadcrumb } from './index';

const reconciliationRoute = {
  path: '/reconciliation',
  name: 'Reconciliation',
  meta: {
    title: 'BNI QRIS - Reconciliation',
    appBarTitle: 'Reconciliation',
  },
  component: Parent,
  children: [
    {
      path: '/reconciliation/regenerate-settlement',
      meta: {
        title: 'BNI QRIS - Regenerate Settlement',
        appBarTitle: 'Regenerate Settlement',
        breadcrumbs: () => [
          setBreadcrumb('reconciliation', '/reconciliation', true),
          setBreadcrumb(
            'regenerate settlement',
            '/reconciliation/regenerate-settlement'
          ),
        ],
      },
      component: RegenerateSettlement,
      name: 'RegenerateSettlement',
    },
    {
      path: '/reconciliation/transaction',
      meta: {
        title: 'BNI QRIS - Transaction Reconciliation',
        appBarTitle: 'Transaction Reconciliation',
        breadcrumbs: () => [
          setBreadcrumb('reconciliation', '/reconciliation', true),
          setBreadcrumb('transaction', '/reconciliation/transaction'),
        ],
      },
      component: TransactionReconciliation,
      name: 'TransactionReconciliation',
    },
  ],
};

export default reconciliationRoute;
